<template>
<ItpBox>
  <ItpSidebar
    default-width="400"
    scroll-y
    class="mr-2"
  >
    <UcInvoiceGeneratorControls
      ref="panel"
    >
    </UcInvoiceGeneratorControls>
  </ItpSidebar>
  <DIV
    class="h-100 w-100 overflow-hidden position-relative"
  >
    <VueSlickgrid
      :name="gridName"
      :resizeTrigger="resizeTrigger"
      :headerTitle="'Draft Invoices'|gettext"
      :items="ds"
      checkbox-row-selection
      footer-totals
      export-to-csv
      :exportToCsvFilename="'draft-invoices'|pgettext('ExportFilename')"
      :columnDefaults="b_1040167445267876_columnDefaults"
      :columns="b_1040167445267876_columns"
      class="page--grid"
      ref="grid"
      @selectedRowsChanged="evh_1040167445267876_selectedRowsChanged($event, {})"
      @command="evh_1040167445267876_command($event, {})"
    >
      <DIV
        class="flex-grow-1 d-flex"
        slot="toolbar"
      >
        <ItpButton
          :icon="$config.billingList.createItemIcon"
          :text="'Bulk edit...'|pgettext('Invoices')"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          @click="evh_7789867021953041_click($event, {})"
        >
        </ItpButton>
        <ItpButton
          icon="fa-trash"
          :text="'Delete'|gettext"
          size="sm"
          variant="light"
          :disabled="!selectedItems || !selectedItems.length"
          :spinning="actions.deleteItems.isRunning"
          class="mx-2"
          @click="evh_3468003412020058_click($event, {})"
        >
        </ItpButton>
        <JobHandlerControl
          jobType="invoice_sync"
          load-current
          :payload="() => onCreateInvoicesPayload()"
          icon="material-symbols:cloud-sync-outline-rounded"
          :text="'Create Invoices'|pgettext('DraftInvoices|Submit')"
          size="sm"
          :disabled="!selectedItems || !selectedItems.length"
        >
        </JobHandlerControl>
        <ItpLink
          :text="'Download invoice lines'|pgettext('InvoiceGeneration')"
          :href="$fn.urlFor('draft_invoice_lines_report')"
          button
          variant="light"
          use-auth
          timeout="300000"
          class="d-inline-block mx-2"
        >
        </ItpLink>
        <ArtifactJob
          icon="ic:baseline-download"
          :text="'Download views'|gettext"
          size="sm"
          :disabled="!selectedItems || !selectedItems.length"
          operation="download_invoice_views"
          :payload="boundDownloadViewsPayloadMethod()"
          class="ml-2"
        >
        </ArtifactJob>
      </DIV>
    </VueSlickgrid>
  </DIV>
</ItpBox>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoiceGenerationInvoices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };
  sse = {
    cleanup: true,
  };

  beforeCreate() {
  }

  processMessage(...args: any[]) {
    const msg = args[0];
    if (msg.event === 'InvoiceGeneratorStatus') {
      this.$refs.panel.updateStatus(msg.data);
    }
    if (msg.event === 'InvoiceCreated') {
      this.$refs.grid.dataView.addItem(msg.data);
    }
    if (msg.event === 'InvoiceUpdated') {
      this.$refs.grid.dataView.updateItem(msg.data.id, msg.data);
    }
    if (msg.event === 'InvoiceDeleted') {
      this.$refs.grid.dataView.removeItem(msg.data.id);
    }
  }

  onCreateInvoicesPayload(...args: any[]) {
    return this.$imodal
      .show({ name: 'CompleteInvoicesAlt' })
      .then(result => {
        if (!result || result.cancel || !result.value) {
          return;
        }
        return this.selectedItems.map(p => ({
          ...result.value,
          invoice_id: p.id,
        }));
      }
      )
  }

  getDownloadViewsPayload(...args: any[]) {
    return {
      identities: _.chain(this.selectedItems)
        .map(p => p.id)
        .uniq()
        .value()
    }
  }

  boundDownloadViewsPayloadMethod(...args: any[]) {
    if (!this._getDownloadViewsPayload) {
      this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
    }
    return this._getDownloadViewsPayload
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  gridName!: any;
  resizeTrigger!: any;
  selectedItems!: any;
  ts!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_draft_invoices')
  }

  ux!: any;
  b_1040167445267876_columnDefaults!: any;
  b_1040167445267876_columns!: any;
  dataMembers = ['gridName', 'resizeTrigger', 'selectedItems', 'ts', 'ds', 'ux', 'b_1040167445267876_columnDefaults', 'b_1040167445267876_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        gridName: "draftInvoices",
        resizeTrigger: 0,
        selectedItems: [
        ]
        ,
        ts: null,
        ds: null,
        ux: null,
        b_1040167445267876_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_1040167445267876_columns: [{
          field: "contract_number",
          name: this.$fn.pgettext("InvoiceBrowserView", "Contract"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "contract",
            navigateOnIconClick: true,
            params: {
              id: "contract_id",
            }
            ,
          }
          ,
        }
          ,
        {
          name: this.$fn.pgettext("Invoices", "Period start"),
          params: {
            sortPath: "billing_period.start",
          }
          ,
          field: "billing_period.start",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "billing_period.start",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          name: this.$fn.pgettext("Invoices", "Period end"),
          params: {
            sortPath: "billing_period.end",
          }
          ,
          field: "billing_period.end",
          type: "date",
          formatter: [{
            name: "getvalue",
            opts: {
              field: "billing_period.end",
            }
            ,
          }
            ,
          ]
          ,
        }
          ,
        {
          field: "invoice_number",
          name: this.$fn.pgettext("InvoiceBrowserView", "Invoice Number"),
          type: "command",
          formatter: {
            name: "link",
            href: "#",
          }
          ,
        }
          ,
        {
          field: "company_name",
          name: this.$fn.pgettext("InvoiceBrowserView", "Company"),
          formatter: {
            name: "routeLink",
            to: "company",
            navigateOnIconClick: true,
            params: {
              id: "company_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "client_name",
          name: this.$fn.pgettext("InvoiceBrowserView", "Client"),
          formatter: {
            name: "routeLink",
            to: "company",
            navigateOnIconClick: true,
            params: {
              id: "client_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "rental_name",
          name: this.$fn.pgettext("InvoiceBrowserView", "Rental"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "rental",
            navigateOnIconClick: true,
            params: {
              id: "rental_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "site_name",
          name: this.$fn.pgettext("InvoiceBrowserView", "Site"),
          type: "command",
          formatter: {
            name: "routeLink",
            to: "property",
            navigateOnIconClick: true,
            params: {
              id: "site_id",
            }
            ,
          }
          ,
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("InvoiceBrowserView", "Billing category"),
        }
          ,
        {
          field: "net_amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "Net"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "vat_amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "VAT"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "amount",
          name: this.$fn.pgettext("InvoiceBrowserView", "Amount"),
          type: "number",
          formatter: {
            name: "number",
          }
          ,
        }
          ,
        {
          field: "currency",
          name: this.$fn.pgettext("InvoiceBrowserView", "Currency"),
        }
          ,
        {
          field: "invoice_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Invoice date"),
          type: "date",
        }
          ,
        {
          field: "fulfillment_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Fulfillment date"),
          type: "date",
        }
          ,
        {
          field: "due_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Due date"),
          type: "date",
        }
          ,
        {
          field: "accounting_date",
          name: this.$fn.pgettext("InvoiceBrowserView", "Accounting date"),
          type: "date",
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_1040167445267876_setData_7468_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_7468, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_1040167445267876_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_showModal_7470_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_1040167445267876_showModal_7470, alias=undefined
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.id,
        modal: true,
      }
      ,
    }
  }

  async evh_1040167445267876_command_7469_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_command_7469, alias=undefined
    return $event.data.column.id === 'invoice_number'
  }

  async evh_1040167445267876_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_command.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_reloadSlickgrid_7474_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_7789867021953041_reloadSlickgrid_7474, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async evh_7789867021953041_close_7473_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_7789867021953041_close_7473, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_7789867021953041_showModal_7472_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_7789867021953041_showModal_7472, alias=undefined
    return {
      name: "BatchInvoiceEditor",
      props: {
        invoices: this.selectedItems,
      }
      ,
    }
  }

  async evh_7789867021953041_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_click.executeFromDOM(this, event, scope);
  }

  async act_3468003412020058_reloadSlickgrid_7478_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_3468003412020058_reloadSlickgrid_7478, alias=undefined
    return {
      grid: this.gridName,
    }
  }

  async act_3468003412020058_request_7476_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_3468003412020058_request_7476, alias=deleteItems
    return {
      operation: "delete_draft_invoices",
      data: {
        invoices: this.selectedItems.map(p => p.id)
      },
    }
  }

  async evh_3468003412020058_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3468003412020058_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_1040167445267876_setData_7468: actions.SetDataAction;
    evh_1040167445267876_selectedRowsChanged_7467: actions.EventHandlerImpl;
    evh_1040167445267876_selectedRowsChanged: actions.EventHandlerGroup;
    act_1040167445267876_showModal_7470: actions.ShowModalAction;
    evh_1040167445267876_command_7469: actions.EventHandlerImpl;
    evh_1040167445267876_command: actions.EventHandlerGroup;
    act_7789867021953041_reloadSlickgrid_7474: actions.ReloadSlickgridAction;
    evh_7789867021953041_close_7473: actions.EventHandlerImpl;
    act_7789867021953041_showModal_7472: actions.ShowModalAction;
    evh_7789867021953041_click_7471: actions.EventHandlerImpl;
    evh_7789867021953041_click: actions.EventHandlerGroup;
    act_3468003412020058_reloadSlickgrid_7478: actions.ReloadSlickgridAction;
    evh_3468003412020058_success_7477: actions.EventHandlerImpl;
    act_3468003412020058_request_7476: actions.RequestAction;
    evh_3468003412020058_click_7475: actions.EventHandlerImpl;
    evh_3468003412020058_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_1040167445267876_setData_7468 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_7468_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_selectedRowsChanged_7467 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_7468,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_1040167445267876_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_selectedRowsChanged_7467],
      }
    );
    const act_1040167445267876_showModal_7470 = new actions.ShowModalAction(
      {
        actionArgs: this.act_1040167445267876_showModal_7470_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_command_7469 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_showModal_7470,
        event: "command",
        when: this.evh_1040167445267876_command_7469_getWhen,
        displayName: "showModal",
      }
    );
    const evh_1040167445267876_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_command_7469],
      }
    );
    const act_7789867021953041_reloadSlickgrid_7474 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_7789867021953041_reloadSlickgrid_7474_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_close_7473 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_reloadSlickgrid_7474,
        event: "close",
        when: this.evh_7789867021953041_close_7473_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_7789867021953041_showModal_7472 = new actions.ShowModalAction(
      {
        actionArgs: this.act_7789867021953041_showModal_7472_getActionArgs,
        events: [evh_7789867021953041_close_7473],
      }
    );
    const evh_7789867021953041_click_7471 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_showModal_7472,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_7789867021953041_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_click_7471],
      }
    );
    const act_3468003412020058_reloadSlickgrid_7478 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_3468003412020058_reloadSlickgrid_7478_getActionArgs,
        events: [],
      }
    );
    const evh_3468003412020058_success_7477 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_reloadSlickgrid_7478,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_3468003412020058_request_7476 = new actions.RequestAction(
      {
        actionArgs: this.act_3468003412020058_request_7476_getActionArgs,
        displayName: "deleteItems",
        events: [evh_3468003412020058_success_7477],
      }
    );
    const evh_3468003412020058_click_7475 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_request_7476,
        event: "click",
        displayName: "deleteItems",
      }
    );
    const evh_3468003412020058_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_3468003412020058_click_7475],
      }
    );
    return {
      act_1040167445267876_setData_7468,
      evh_1040167445267876_selectedRowsChanged_7467,
      evh_1040167445267876_selectedRowsChanged,
      act_1040167445267876_showModal_7470,
      evh_1040167445267876_command_7469,
      evh_1040167445267876_command,
      act_7789867021953041_reloadSlickgrid_7474,
      evh_7789867021953041_close_7473,
      act_7789867021953041_showModal_7472,
      evh_7789867021953041_click_7471,
      evh_7789867021953041_click,
      act_3468003412020058_reloadSlickgrid_7478,
      evh_3468003412020058_success_7477,
      act_3468003412020058_request_7476,
      evh_3468003412020058_click_7475,
      evh_3468003412020058_click,
      deleteItems: act_3468003412020058_request_7476,
    }
  }
}

Vue.component("UcInvoiceGenerationInvoices", UcInvoiceGenerationInvoices);

</script>